import { User } from '@core/redux/stores/user.store';
import { TokenInfo } from '@core/redux/stores/token-info.store';

export class AuthResponse {
    tokenInfo: TokenInfo;
    user: User;

    constructor() {
      this.tokenInfo = new TokenInfo();
      this.user = new User();
    }
}
